module.exports = __webpack_public_path__ + "img/gucci.eeabbec9.jpg";